import * as Highcharts from 'highcharts/highstock';
import { TimeLevelEnum } from '../enum/timelevel';

var isMobileOutsideMarketLanding = window.innerWidth <= 430 && window.location.pathname.toLowerCase().includes('outsidemarketlanding');

export function getRangeSelectorOptions(timelevel: TimeLevelEnum) {
    switch(timelevel) {
        case TimeLevelEnum.Daily:
            return [{
                type: 'month',
                count: 3,
                text: '3m',
                title: 'View 3 months'
            }, {
                type: 'month',
                count: 6,
                text: '6m',
                title: 'View 6 months'
            }, {
                type: 'year',
                count: 1,
                text: '1y',
                title: 'View 1 year'
            }, {
                type: 'year',
                count: 3,
                text: '3y',
                title: 'View 3 years'
            }, {
                type: 'all',
                text: 'All',
                title: 'View all',
                dataGrouping: {
                    forced: true,
                    units: [['month', [1]]]
                }
            }];
        default:
            return [];
    }
}

export function getDateFormatterByTimelevel(timelevel: TimeLevelEnum) {
    switch(timelevel) {
        case TimeLevelEnum.Daily:
            return '%m/%d/%Y';
        case TimeLevelEnum.Weekly:
            return '%m/%d/%Y';
        case TimeLevelEnum.Monthly:
            return '%b, %Y';
        case TimeLevelEnum.Quarterly:
            return '%b, %Y';
        case TimeLevelEnum.Yearly:
            return '%Y';
        default:
            return '%m/%d/%Y';
    }
}

export function drawCurrencyOnChart(chart: any, currencyName: string, iteration: string = '', rangeSelectorEnabled: boolean = true) {
    if (!currencyName)
        return;
    $("#currencyName" + iteration).html(currencyName);

    $("#chart-currencylabel" + iteration).remove();

    let fontSize = isMobileOutsideMarketLanding ? '1rem' : '1.125rem';

    var label = chart['renderer']['label']('Expressed in ' + currencyName)
        .css({
            minWidth: '400px',
            color: "#00F900",
            fontSize,
            textAlign: 'left',
            fontFamily: 'ProximaNova-Regular'
        })
        .attr({
            stroke: 'grey',
            strokeWidth: 0,
            r: 5,
            padding: 3,
            class: 'hidden-phone',
            id: 'chart-currencylabel' + iteration
        })
        .add();

        let y = rangeSelectorEnabled ? 65 : 35;

        if(isMobileOutsideMarketLanding) {
            y += 25;
        }

    label.align(Highcharts.extend(label.getBBox(), {
        align: 'left',
        x: 0, // offset
        verticalAlign: 'top',
        y
    }), null, 'spacingBox');
}

export function drawTimePeriodOnChart(chart: any, timePeriod: string, iteration = '', rangeSelectorEnabled = true, hideTimelevel = false) {
    $("#chart-timelevellabel" + iteration).remove();

    if(hideTimelevel) {
        return;
    }

    let fontSize = isMobileOutsideMarketLanding ? '1rem' : '1.5rem';

    var label = chart.renderer.label(timePeriod)
        .css({
            width: '300px',
            color: "#F808F2",
            fontSize,
            fontStyle: 'italic',
            textAlign: 'right',
            fontFamily: 'ProximaNova-Regular'
        })
        .attr({
            stroke: 'grey',
            strokeWidth: 0,
            r: 5,
            class: 'hidden-phone',
            padding: 3,
            id: 'chart-timelevellabel' + iteration
        })
        .add();

    let x = timePeriod.length > 7 ? -(130 + ((timePeriod.length - 7) * 10)) : -130;
    let y = rangeSelectorEnabled ? 60 : 30;

    if(isMobileOutsideMarketLanding) {
        x = -60;
        y += 30;
    }

    label.align(Highcharts.extend(label.getBBox(), {
        align: 'right',
        x,
        verticalAlign: 'top',
        y
    }), null, 'spacingBox');
}

export function drawLegendLabelOnChart(chart: any, iteration: string = '') {
    $("#chart-legendLabel" + iteration).remove();

    var label = chart['renderer']['label']('Note: some numbers may not fit into mouse over display when all or multiple studies are turned on. Click on any study to turn on/off.')
        .css({
            width: '400px',
            color: "#F808F2",
            fontSize: '12px',
            fontStyle: 'italic',
            textAlign: 'center',
            fontFamily: 'ProximaNova-Regular'
        })
        .attr({
            stroke: 'grey',
            strokeWidth: 0,
            r: 5,
            class: 'hidden-phone',
            padding: 3,
            id: 'chart-legendLabel' + iteration
        })
        .add();

    label.align(Highcharts.extend({}, {
        align: 'center',
        x: -180, // offset
        verticalAlign: 'bottom',
        y: 0 // offset
    }), null, 'spacingBox');
}